import { render, staticRenderFns } from "./original-edit-table.vue?vue&type=template&id=611611d1&scoped=true&"
import script from "./original-edit-table.vue?vue&type=script&lang=js&"
export * from "./original-edit-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611611d1",
  null
  
)

export default component.exports